// Client-side sorting for the Golfers table on a tournament page.
//
// Every sortable <th> carries data-sort-key and data-sort-type; the matching
// cell in each row carries data-cell with the same key and a data-value holding
// the raw figure. Sorting reads data-value rather than the rendered text so an
// em dash placeholder never parses as a number and "9" never sorts after "10".
//
// Sorting is presentational only -- it reorders existing <tr> elements and
// never recalculates anything. The server renders the table in name order,
// which stays the default until a heading is clicked.

const TournamentGolferTable = {
  init() {
    document.querySelectorAll('[data-golfer-table]').forEach((table) => {
      if (table.dataset.sortReady === 'true') return;
      table.dataset.sortReady = 'true';

      const body = table.querySelector('tbody');
      if (!body) return;

      // Captured once, in the server's order, so repeated sorts never compound
      // and a click can always return the table to how it arrived.
      const original = Array.from(body.querySelectorAll('tr'));

      table.querySelectorAll('[data-sort-key]').forEach((heading) => {
        heading.addEventListener('click', () => sort(table, body, original, heading));
      });
    });
  }
};

function sort(table, body, original, heading) {
  const key = heading.dataset.sortKey;
  const numeric = heading.dataset.sortType === 'number';

  // Scores, handicaps and names all read lowest-first. Clicking the same
  // heading again reverses it.
  const direction = heading.getAttribute('aria-sort') === 'ascending' ? 'descending' : 'ascending';

  table.querySelectorAll('[data-sort-key]').forEach((other) => {
    other.removeAttribute('aria-sort');
    other.classList.remove('text-gray-700');
  });
  heading.setAttribute('aria-sort', direction);
  heading.classList.add('text-gray-700');

  const value = (row) => {
    const cell = row.querySelector(`[data-cell="${key}"]`);
    const raw = cell ? cell.dataset.value : '';
    return raw === undefined || raw === null ? '' : raw.trim();
  };

  const sorted = original.slice().sort((rowA, rowB) => {
    const a = value(rowA);
    const b = value(rowB);

    // A golfer with no figure sorts to the bottom either way, so reversing the
    // direction never parades the blanks to the top.
    if (a === '' && b === '') return 0;
    if (a === '') return 1;
    if (b === '') return -1;

    const comparison = numeric
      ? parseFloat(a) - parseFloat(b)
      : a.localeCompare(b, undefined, { sensitivity: 'base' });

    return direction === 'ascending' ? comparison : -comparison;
  });

  sorted.forEach((row) => body.appendChild(row));
}

document.addEventListener('turbolinks:load', () => TournamentGolferTable.init());

// Turbolinks caches the DOM as it stands, data-sort-ready included, so without
// this a restored page would come back with the flag set and no listeners.
document.addEventListener('turbolinks:before-cache', () => {
  document.querySelectorAll('[data-golfer-table]').forEach((table) => {
    delete table.dataset.sortReady;
  });
});
